import styled from 'styled-components';

export const StyledInput = styled.input`
    ::placeholder {
        opacity: ${(props) => props.opacity};
    }
`;

export const AdjustPriceTextboxWrapper = styled.div`
    input{
        color: #565656;
        opacity: 0.8;
        ::placeholder {
            color: #565656 !important;
            opacity: 0.3 !important;
        }
    }
    .adjustedPriceInput::placeholder {
        color: #565656 !important;
        opacity: 0.3 !important;
    }
`;
